import React from "react";

export const PaziaHeader = ({ children }: React.PropsWithChildren): JSX.Element | null => {
  return <span className="text-2xl md:text-3xl text-slate-800 dark:text-slate-100 font-bold truncate">{children}</span>;
};
